import axios from "../../config/axiosConfig";
import { getRawMaterialReturnChallanTransactionTakaNo } from './raw-material-return-challan-transaction-actions';
import { getRawMaterialInwardChallans } from './raw-material-inward-challan-actions';
import { getRawMaterialInwardChallanTransaction, getRawMaterialInwardChallanTransactionTakaNo } from './raw-material-inward-challan-transaction-actions';
import { CREATE_RAW_MATERIAL_RETURN_CHALLAN, GET_RAW_MATERIAL_RETURN_CHALLANS, RAW_MATERIAL_RETURN_CHALLAN_REQUEST, UPDATE_RAW_MATERIAL_RETURN_CHALLAN, 
  DELETE_RAW_MATERIAL_RETURN_CHALLAN, RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE } from "../types";

export const getRawMaterialReturnChallans = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/raw-material-return-challan/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_RAW_MATERIAL_RETURN_CHALLANS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createRawMaterialReturnChallan = (rawMaterialReturnChallan) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST });
      const newRawMaterialReturnChallan = {
        ...rawMaterialReturnChallan
      };
      return axios.post("/raw-material-return-challan/add", newRawMaterialReturnChallan,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_RAW_MATERIAL_RETURN_CHALLAN, payload: response.data });
          dispatch(getRawMaterialReturnChallanTransactionTakaNo());
          dispatch(getRawMaterialInwardChallans());
          dispatch(getRawMaterialInwardChallanTransaction());
          dispatch(getRawMaterialInwardChallanTransactionTakaNo());
        } else {
          dispatch({
            type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE,
            error: "Raw Material Return Challan Create Failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateRawMaterialReturnChallan = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST });
      const { auth } = getState();
      return axios.put("/raw-material-return-challan/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_RAW_MATERIAL_RETURN_CHALLAN,
            payload: { id, data: response.data },
          });
          dispatch(getRawMaterialReturnChallanTransactionTakaNo());
          dispatch(getRawMaterialInwardChallans());
          dispatch(getRawMaterialInwardChallanTransaction());
          dispatch(getRawMaterialInwardChallanTransactionTakaNo());
        } else {
          dispatch({
            type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE,
            error: "Raw Material Return Challan update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteRawMaterialReturnChallan = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST });
      const { auth } = getState();
      return axios.delete(`/raw-material-return-challan/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_RAW_MATERIAL_RETURN_CHALLAN, id: id });
          dispatch(getRawMaterialReturnChallanTransactionTakaNo());
          dispatch(getRawMaterialInwardChallans());
          dispatch(getRawMaterialInwardChallanTransaction());
          dispatch(getRawMaterialInwardChallanTransactionTakaNo());
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};